import Main from './_main';
import Home from './_home';
import Business from './_business';
import Member from './_member';
import Requirements from './_requirements';
import Job from './_job';
import Technology from './_technology';
import Workplace from './_workplace';
// import Education from './_education';

new Main();
new Home();
new Business();
new Member();
new Requirements();
new Job();
new Technology();
new Workplace();
// new Education();
